import React from "react";
import "./CityOverview.css";

const CityOverview = ({ insight }) => {
  return (
    <div className="overview_wrapper_ac">
      {/* Left Card */}
      <div className="overview_card_ac">
        <div className="overview_icon_ac">
          <i className="fa-solid fa-location-dot"></i>
        </div>
        <h3 className="overview_title_ac">{insight?.city?.name} Overview</h3>
        <p className="overview_desc_ac">
          Top rated localities and commercial hubs in the region.
        </p>
        <span className="overview_link_ac">
          <a
            style={{ textDecoration: "none" }}
            href={insight?.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Map <i class="fa-solid fa-arrow-right arrow-icon"></i>
          </a>
        </span>
      </div>

      {/* Right Content */}
      <div className="overview_content_ac">
        {/* Localities */}
        <div className="overview_column_ac">
          <h4 className="overview_heading_ac">
            <i className="fa-solid fa-location-dot"></i> Localities
          </h4>
          <ul className="overview_list_ac">
            {insight?.localities?.map((e, i) => {
              return <li>{e?.name}</li>;
            })}
          </ul>
        </div>

        {/* Apartments */}
        <div className="overview_column_ac">
          <h4 className="overview_heading_ac">
            <i className="fa-solid fa-building"></i> Apartments
          </h4>
          <ul className="overview_list_ac">
            {insight?.apartments?.map((e, i) => {
              return <li>{e?.aptName}</li>;
            })}
          </ul>
        </div>

        {/* Commercial */}
        <div className="overview_column_ac">
          <h4 className="overview_heading_ac">
            <i className="fa-solid fa-city"></i> Commercial
          </h4>
          <ul className="overview_list_ac">
            {insight?.commercials?.map((e, i) => {
              return <li>{e}</li>;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CityOverview;
